import React from 'react';
import { Helmet } from 'react-helmet';

const JobDetailsSEO = ({ seoData, job }) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <meta name="keywords" content={`${job.title}, ${job.company_name}, ${job.skills_required?.join(', ')}, virtual assistant jobs, remote work, ${job.location}`} />
      <link rel="canonical" href={seoData.url} />

      {/* Open Graph Tags */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      <meta property="og:url" content={seoData.url} />
      <meta property="og:image" content={seoData.image} />
      <meta property="og:site_name" content="VA Sprouts" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
      <meta name="twitter:image" content={seoData.image} />

      {/* Additional Meta Tags */}
      <meta name="author" content={job.company_name} />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(seoData.structuredData)}
      </script>

      {/* Additional Structured Data for BreadcrumbList */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": `${window.location.origin}`
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Jobs",
              "item": `${window.location.origin}/job-search`
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": job.title,
              "item": seoData.url
            }
          ]
        })}
      </script>
    </Helmet>
  );
};

export default JobDetailsSEO;